// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReactPortal from "react-portal";
var Portal = {};
function PortalEmptying(Props) {
  var node = Props.node;
  var children = Props.children;
  var hasMounted = node.hasAttribute("data-portal-emptied");
  if (!hasMounted) {
    node.setAttribute("data-portal-emptied", "true");
    node.innerHTML = "";
  }
  return React.createElement(ReactPortal.Portal, {
    node: node,
    children: children
  });
}
PortalEmptying.displayName = "PortalEmptying";
var make = PortalEmptying;
export { Portal, make };
/* react Not a pure module */